<div #formTop>
  <form *ngIf="baseFormGroup"
   [formGroup]="baseFormGroup"
   #f="ngForm"
   class="mt-4 pl-2"
  >
    <div class="collapsable-container" style="margin-bottom:8px;">
      <div class="collapsable-container-header" (click)="toggleCollapseOtpremnica()"
        [ngStyle]="{'background-color': '#d7e4f2', 'border-bottom': '1px solid #b7c7d3'}" *ngIf="izlazna">
        <span class="btn-collapse" (click)="toggleCollapseOtpremnica($event)">
          <span class="fa fa-fw fa-angle-double-down" *ngIf="izlazna"></span>
        </span>
        <div class="heading">{{modelData.MainTitle}}</div>
      </div>

      <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsedOtpremnica}">
        <div class="row">
          <div class="col-md-12">
            <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
              #{{fc.ID.value}}
            </div>

            <div class="row">
              <!-- Podvrsta dokumenta -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-dropdown-picklist
                      [ModelName]="'podvrstadokumentastavka'"
                      [GetName]="'GetByUrl'"
                      [ModelProperty]="'Sifra,Naziv'"
                      [GetParameters]="modelData.MainList.GetParameters"
                      formControlName="PodVrstaDokumentaStavkaID"
                      [Label]="'EOTPREMNICA.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                      [ngClass]="{
                        'is-invalid':
                        submitted && fc.PodVrstaDokumentaStavkaID.invalid
                      }"
                      (OnItemSelected)="onPodVrstaSelect($event)"
                      [Width]="'600px'"
                      #autofocus
                      [Required]="IsRequired('PodVrstaDokumentaStavkaID')"
                      [AutoSelect]="true"
                      [AllowAddNew]="true"
                      [Parameters]="parametersForPodvrstaDokumentStavka"
                      (GetItems)="PodvrstaDokumentaGetItems($event)">
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                      <span *ngFor="
                        let validation of errorMessages.PodVrstaDokumentaStavkaID
                        ">
                        <span class="error-message" *ngIf="
                            fc.PodVrstaDokumentaStavkaID.hasError(validation.type)
                        ">
                          <span translate="{{ validation.message }}"></span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Datum dokumenta -->
              <div class="col-lg-2 col-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-fw-date-picker-popup
                      #dtpDatumDokumenta
                      formControlName="Datum"
                      name="txtDatDok"
                      [Label]="'EOTPREMNICA.DATDOK.SINGULAR'"
                      [ngClass]="{ 'is-invalid': submitted && fc.Datum.invalid }"
                      (OnDateSelected)="onDatumChange($event)"
                    >
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                      <span *ngFor="let validation of errorMessages.Datum">
                        <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Broj dokumenta -->
              <div class="col-lg-2 col-12">
                <div class="form-group row">
                  <div class="col-md-8 col-8">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BRDOK.SINGULAR'" formControlName="Broj" [ngClass]="{
                        'is-invalid': submitted && fc.Broj.invalid
                    }">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                      <span *ngFor="let validation of errorMessages.Broj">
                        <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4 col-4">
                    <div class="input-group-append">
                      <span class="span-control">/</span>
                      <span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{
                        baseFormGroup.get("Datum").value.year }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!--Tip otpremnice-->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-dropdown-picklist
                      #ddlTipOtpremnice
                      [ModelName]="'tipotpremnice'"
                      [GetName]="'get'"
                      [ModelProperty]="'Naziv'"
                      [OrderBy]="'Naziv'"
                      [AllowAddNew]="false"
                      formControlName="TipOtpremniceID"
                      [Label]="'EOTPREMNICA.TIPOTPREMNICE.SINGULAR'"
                      [Width]="'xl'"
                      [Position]="'left'"
                      [ngClass]="{'is-invalid': submitted && fc.TipOtpremniceID.invalid}"
                      (GetItems)="TipOtpremniceGetItems($event)"
                      (OnItemSelected)="onTipOtpremniceSelect($event)"
                    >
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.TipOtpremniceID.invalid">
                      <span *ngFor="let validation of errorMessages.TipOtpremniceID">
                        <span class="error-message" *ngIf="fc.TipOtpremniceID.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!--Objekat pošiljaoca-->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-dropdown-picklist
                      #ddlObjekatPosiljaoca
                      [ModelName]="'firmaobjekat'"
                      [GetName]="'GetByFirmaID'"
                      [ModelProperty]="'Naziv,MestoNaziv'"
                      [OrderBy]="'Naziv'"
                      [AllowAddNew]="false"
                      formControlName="ObjekatPosiljaocaID"
                      [Label]="'EOTPREMNICA.OBJEKATPOSILJAOCA.SINGULAR'"                      
                      [Position]="'right'"
                      [ngClass]="{'is-invalid': submitted && fc.ObjekatPosiljaocaID.invalid}"
                      (GetItems)="ObjekatPosiljaocaGetItems($event)"
                      [Required]="false"
                    >
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.ObjekatPosiljaocaID.invalid">
                      <span *ngFor="let validation of errorMessages.ObjekatPosiljaocaID">
                        <span class="error-message" *ngIf="fc.ObjekatPosiljaocaID.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Povrat -->
              <div class="col-md-1">
                <div class="form-group row">
                  <div class="col-md-12">
                    <div class="form-check" style="padding-top: 22px">
                      <input class="form-check-input" type="checkbox" formControlName="Povrat" id="chkPovrat">
                      <label class="form-check-label" for="chkPovrat">
                        <span translate="EOTPREMNICA.POVRAT.SINGULAR"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!--Način otpreme-->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-dropdown-picklist
                      #ddlNacinOtpreme
                      [ModelName]="'nacinotpreme'"
                      [GetName]="'get'"
                      [ModelProperty]="'Naziv'"
                      [OrderBy]="'Naziv'"
                      [AllowAddNew]="false"
                      formControlName="NacinOtpremeID"
                      [Label]="'EOTPREMNICA.NACINOTPREME.SINGULAR'"
                      [ngClass]="{'is-invalid': submitted && fc.NacinOtpremeID.invalid}"
                      (GetItems)="NacinOtpremeGetItems($event)"
                      (OnItemSelected)="onNacinOtpremeSelect($event)"
                    >
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.NacinOtpremeID.invalid">
                      <span *ngFor="let validation of errorMessages.NacinOtpremeID">
                        <span class="error-message" *ngIf="fc.NacinOtpremeID.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                    <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                      <span class="error-message"
                        *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsNacinOtpreme && !this.baseFormGroup.errors.checkControlsNacinOtpreme.valid"><span
                          translate="{{this.baseFormGroup.errors.checkControlsNacinOtpreme.message}}"></span></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- PlaniranoVremeDostave (Planirani datum i vreme početka otpreme - EstimatedDespatchPeriod (StartDate/StartTime)) -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-date-time-picker-popup #dtPickerPlaniraniPocetakOtpreme
                      formControlName="PlaniraniPocetakOtpreme" name="txtPlaniraniPocetakOtpreme"
                      [Label]="'EOTPREMNICA.PLANIRANIPOCETAKOTPREME.SINGULAR'"                    
                      [ngbTooltip]="('EOTPREMNICA.PLANIRANIPOCETAKOTPREME.TOOLTIP' | translate )"
                        [minuteStep]="1"
                        [hourStep]="1"
                      triggers="mouseenter:mouseleave"
                      container="body"
                    >
                    </yt-date-time-picker-popup>
                   <!-- ngbTooltip="{{'EOTPREMNICA.PLANIRANIPOCETAKOTPREME.TOOLTIP' | translate }}" -->
                     <div class="form-error" *ngIf="submitted && fc.PlaniraniPocetakOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.PlaniraniPocetakOtpreme">
                        <span class="error-message" *ngIf="fc.PlaniraniPocetakOtpreme.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Vreme dostave (Planirani datum i vreme završetka otpreme - EstimatedDeliveryPeriod (EndDate/EndTime)) -->

              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-date-time-picker-popup #dtPickerPlaniraniZavrsetakOtpreme
                      formControlName="PlaniraniZavrsetakOtpreme" name="txtPlaniraniZavrsetakOtpreme"
                      [Label]="'EOTPREMNICA.PLANIRANIZAVRSETAKOTPREME.SINGULAR'"
                       [minuteStep]="1"
                        [hourStep]="1"
                    >
                    </yt-date-time-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.PlaniraniZavrsetakOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.PlaniraniZavrsetakOtpreme">
                        <span class="error-message" *ngIf="fc.PlaniraniZavrsetakOtpreme.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!--  (Stvarni datum i vreme otpreme - ActualDespatchPeriod) -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-date-time-picker-popup #dtPickerStvarnoVremeDostave formControlName="StvarnoVremeDostave"
                      name="txtStvarnoVremeDostave"
                      [Label]="'EOTPREMNICA.STVARNOVREMEDOSTAVE.SINGULAR'"
                       [minuteStep]="1"
                        [hourStep]="1"
                    >
                    </yt-date-time-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.StvarnoVremeDostave.invalid">
                      <span *ngFor="let validation of errorMessages.StvarnoVremeDostave">
                        <span class="error-message" *ngIf="fc.StvarnoVremeDostave.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>



        <!-- Podaci o primaocu -->
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!--Primaoc-->
              <div class="col-lg-6">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-dropdown-picklist #ddlPrimaoc [ModelName]="'komitent'" [GetName]="'getByDrzava'"
                      [GetParameters]="parameterListZaPrimaoce" [ModelProperty]="'SNaziv,Mesto'" [OrderBy]="'SNaziv'"
                      [AllowAddNew]="true" formControlName="PrimaocID" [Label]="'EOTPREMNICA.PRIMAOC.SINGULAR'"
                      [Width]="'l'" [Position]="'left'" (OnItemSelected)="onPrimaocSelect($event)"
                      [ngClass]="{'is-invalid': submitted && fc.PrimaocID.invalid}"
                      (GetItems)="PrimaocGetItems($event)">
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.PrimaocID.invalid">
                      <span *ngFor="let validation of errorMessages.PrimaocID">
                        <span class="error-message" *ngIf="fc.PrimaocID.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!--Objekat primaoca-->
              <div class="col-lg-6">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-dropdown-picklist
                      #ddlObjekatPrimaoca
                      [ModelName]="'komitentobjekat'"
                      [GetName]="'GetByKomitentID'"
                      [ModelProperty]="'NazivObjekta,MestoNaziv'"
                      [OrderBy]="'NazivObjekta'"
                      [AllowAddNew]="true"
                      formControlName="ObjekatPrimaocaID"
                      [Label]="'EOTPREMNICA.OBJEKATPRIMAOCA.SINGULAR'"
                      [Width]="'xl'"
                      [Position]="'left'"
                      [ngClass]="{'is-invalid': submitted && fc.ObjekatPrimaocaID.invalid}"
                      (GetItems)="ObjekatPrimaocaGetItems($event)"
                      [GetParameters]="parameterListZaObjektePrimaoca"
                      [Required]="false"
                    >
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.ObjekatPrimaocaID.invalid">
                      <span *ngFor="let validation of errorMessages.ObjekatPrimaocaID">
                        <span class="error-message" *ngIf="fc.ObjekatPrimaocaID.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-6">
            <yt-dropdown-picklist 
              [ModelName]="'jedinicamere'" 
              [GetName]="'get'" 
              [ModelProperty]="'Oznaka,Naziv'" 
              [OrderBy]="'Naziv'"
              [AllowAddNew]="false" 
              formControlName="JedinicaMereZaTezinu" 
              [Label]="'EOTPREMNICA.JEDINICAMEREZATEZINU.SINGULAR'">
            </yt-dropdown-picklist>
          </div>
         <div class="col-md-6">
            <yt-number-input-v3
              name="txtTezinaIsporuke" 
              [Label]="'EOTPREMNICA.TEZINAISPORUKE.SINGULAR'" 
              formControlName="TezinaIsporuke">
            </yt-number-input-v3>
            <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
               <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.CheckTezinaIsporuke && !this.baseFormGroup.errors.CheckTezinaIsporuke.valid"><span translate="{{this.baseFormGroup.errors.CheckTezinaIsporuke.message}}"></span></span>
              </div>
          </div>
        </div>
          <div class="form-group row">
          <div class="col-md-6">
              <yt-dropdown-picklist 
              [ModelName]="'jedinicamere'" 
              [GetName]="'get'" 
              [ModelProperty]="'Oznaka,Naziv'" 
              [OrderBy]="'Naziv'"
              [AllowAddNew]="false" 
              formControlName="JedinicaMereZaZapreminu" 
              [Label]="'EOTPREMNICA.JEDINICAMEREZAZAPREMINU.SINGULAR'">
            </yt-dropdown-picklist>
          </div>
          <div class="col-md-6">
                <yt-number-input-v3
                name="txtZapreminaIsporuke" 
                [Label]="'EOTPREMNICA.ZAPREMINAISPORUKE.SINGULAR'" 
                formControlName="ZapreminaIsporuke">
              </yt-number-input-v3>
              <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.CheckZapreminaIsporuke && !this.baseFormGroup.errors.CheckZapreminaIsporuke.valid"><span translate="{{this.baseFormGroup.errors.CheckZapreminaIsporuke.message}}"></span></span>
              </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <yt-text-area [MaxLength]="500" name="txtNapomena" formControlName="Napomena"
              [Label]="'EOTPREMNICA.NAPOMENA.SINGULAR'">
            </yt-text-area>
          </div>
        </div>
        <div class="row mb-2" *ngIf="izlazna">
          <div class="col-md-12">
            <div class="btn-group float-right">
              <button type="button" class="btn btn-outline-primary"
                (click)="KreirajIzlaznuOtpremnicu()"
                [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"
                ngbTooltip="{{'EOTPREMNICA.KREIRAJIZLAZNUOTPREMNICU.TOOLTIP' | translate }}"
              >
                <span class="fa fa-fa fa-save"></span>
                {{Item.ID === -1 ? 'Kreiraj izlaznu otpremnicu' : 'Rekreiraj izlaznu otpremnicu' }}
              </button>
              <button
                type="button"
                class="btn btn-outline-primary"
                (click)="SaveItem()"
                [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable || !dozvoliSnimanje"
              ><span class="fa fa-fa fa-save"></span>
                Sačuvaj</button>              
              <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="collapsable-container" style="margin-bottom:8px;" *ngIf="!izlazna">
    <!-- <div class="collapsable-container" style="margin-bottom:8px;"> -->
      <div class="collapsable-container-header" (click)="toggleCollapseDetaljiOOtpremnici()">
        <span class="btn-collapse" (click)="toggleCollapseDetaljiOOtpremnici($event)"><span
            class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'EOTPREMNICA.DETALJIOOTPREMNICI.TITLE' | translate }}</div>
      </div>
      <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsedDetaljiOOtpremnici}">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Broj otpremnice -->
              <div class="col-lg-3" *ngIf="izlazna">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJOTPREMNICE.SINGULAR'"
                      formControlName="BrojOtpremnice" [ngClass]="{
                'is-invalid': submitted && fc.BrojOtpremnice.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.BrojOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.BrojOtpremnice">
                        <span class="error-message" *ngIf="fc.BrojOtpremnice.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3" *ngIf="!izlazna">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJULAZNEOTPREMNICE.SINGULAR'"
                      formControlName="BrojUlazneOtpremnice" [ngClass]="{
                'is-invalid': submitted && fc.BrojUlazneOtpremnice.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <!-- <div class="form-error" *ngIf="submitted && fc.BrojOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.BrojOtpremnice">
                        <span class="error-message" *ngIf="fc.BrojOtpremnice.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div> -->
                  </div>
                </div>
              </div>

              <!-- Datum otpremnice -->
              <!-- <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.DATUMOTPREMNICE.SINGULAR'"
                      formControlName="DatumOtpremnice" [ngClass]="{
                'is-invalid': submitted && fc.DatumOtpremnice.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.DatumOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.DatumOtpremnice">
                        <span class="error-message" *ngIf="fc.DatumOtpremnice.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="col-lg-2 col-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-fw-date-picker-popup #dtpDatumOtpremnice formControlName="DatumOtpremnice"
                      name="txtDatumOtpremnice" [Label]="'EOTPREMNICA.DATUMOTPREMNICE.SINGULAR'"
                      [ngClass]="{ 'is-invalid': submitted && fc.DatumOtpremnice.invalid }"
                      (OnDateSelected)="onDatumOtpremniceChange($event)">
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.DatumOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.DatumOtpremnice">
                        <span class="error-message" *ngIf="fc.DatumOtpremnice.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Tip otpremnice -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.TIPOTPREMNICE.SINGULAR'"
                      formControlName="TipOtpremnice" [ngClass]="{
                'is-invalid': submitted && fc.TipOtpremnice.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.TipOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.TipOtpremnice">
                        <span class="error-message" *ngIf="fc.TipOtpremnice.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Način otpreme -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.NACINOTPREME.SINGULAR'"
                      formControlName="NacinOtpreme" [ngClass]="{
                'is-invalid': submitted && fc.NacinOtpreme.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.NacinOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.NacinOtpreme">
                        <span class="error-message" *ngIf="fc.NacinOtpreme.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2" *ngIf="izlazna">
          <div class="col-md-12">
            <div class="btn-group float-right">
              <button type="button" class="btn btn-outline-primary" (click)="SaveItem()"
                [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable || !dozvoliSnimanje"
              ><span class="fa fa-fa fa-save"></span>
                Sačuvaj</button>
              <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="collapsable-container" style="margin-bottom:8px;">
      <div class="collapsable-container-header" (click)="toggleCollapseDetaljiOPosiljaocu()">
        <span class="btn-collapse" (click)="toggleCollapseDetaljiOPosiljaocu($event)"><span
            class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'EOTPREMNICA.DETALJIOPOSILJAOCU.TITLE' | translate }}</div>
      </div>
      <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsedDetaljiOPosiljaocu}">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Naziv pošiljaoca -->
              <div class="col-lg-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.NAZIVPOSILJAOCA.SINGULAR'"
                      formControlName="NazivPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.NazivPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.NazivPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.NazivPosiljaoca">
                        <span class="error-message" *ngIf="fc.NazivPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Naziv pošiljaoca2 -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.NAZIVPOSILJAOCA2.SINGULAR'"
                      formControlName="NazivPosiljaoca2"
                      [ngClass]="{'is-invalid': submitted && fc.NazivPosiljaoca2.invalid}" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.NazivPosiljaoca2.invalid">
                      <span *ngFor="let validation of errorMessages.NazivPosiljaoca2">
                        <span class="error-message" *ngIf="fc.NazivPosiljaoca2.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Ime i prezime pošiljaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.IMEIPREZIMEPOSILJAOCA.SINGULAR'"
                      formControlName="ImeIPrezimePosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.ImeIPrezimePosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.ImeIPrezimePosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.ImeIPrezimePosiljaoca">
                        <span class="error-message" *ngIf="fc.ImeIPrezimePosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Ulica pošiljaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.ULICAPOSILJAOCA.SINGULAR'"
                      formControlName="UlicaPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.UlicaPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.UlicaPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.UlicaPosiljaoca">
                        <span class="error-message" *ngIf="fc.UlicaPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Broj u ulici pošiljaoca -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJUULICIPOSILJAOCA.SINGULAR'"
                      formControlName="BrojUUliciPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.BrojUUliciPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.BrojUUliciPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.BrojUUliciPosiljaoca">
                        <span class="error-message" *ngIf="fc.BrojUUliciPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Poštanski broj pošiljaoca -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.POSTANSKIBROJPOSILJAOCA.SINGULAR'"
                      formControlName="PostanskiBrojPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.PostanskiBrojPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.PostanskiBrojPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.PostanskiBrojPosiljaoca">
                        <span class="error-message" *ngIf="fc.PostanskiBrojPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Grad pošiljaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.GRADPOSILJAOCA.SINGULAR'"
                      formControlName="GradPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.GradPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.GradPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.GradPosiljaoca">
                        <span class="error-message" *ngIf="fc.GradPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Dodatno ulica pošiljaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.DODATNOULICAPOSILJAOCA.SINGULAR'"
                      formControlName="DodatnoUlicaPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.DodatnoUlicaPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.DodatnoUlicaPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.DodatnoUlicaPosiljaoca">
                        <span class="error-message" *ngIf="fc.DodatnoUlicaPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Telefon pošiljaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.TELEFONPOSILJAOCA.SINGULAR'"
                      formControlName="TelefonPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.TelefonPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.TelefonPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.TelefonPosiljaoca">
                        <span class="error-message" *ngIf="fc.TelefonPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Email pošiljaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.EMAILPOSILJAOCA.SINGULAR'"
                      formControlName="EmailPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.EmailPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.EmailPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.EmailPosiljaoca">
                        <span class="error-message" *ngIf="fc.EmailPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Pib pošiljaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.PIBPOSILJAOCA.SINGULAR'"
                      formControlName="PibPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.PibPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.PibPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.PibPosiljaoca">
                        <span class="error-message" *ngIf="fc.PibPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- JBKJS pošiljaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.JBKJSPOSILJAOCA.SINGULAR'"
                      formControlName="JBKJSPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.JBKJSPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.JBKJSPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.JBKJSPosiljaoca">
                        <span class="error-message" *ngIf="fc.JBKJSPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Matični broj pošiljaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.MATICNIBROJPOSILJAOCA.SINGULAR'"
                      formControlName="MaticniBrojPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.MaticniBrojPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.MaticniBrojPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.MaticniBrojPosiljaoca">
                        <span class="error-message" *ngIf="fc.MaticniBrojPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Gln pošiljaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.GLNPOSILJAOCA.SINGULAR'"
                      formControlName="GlnPosiljaoca" [ngClass]="{
                'is-invalid': submitted && fc.GlnPosiljaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.GlnPosiljaoca.invalid">
                      <span *ngFor="let validation of errorMessages.GlnPosiljaoca">
                        <span class="error-message" *ngIf="fc.GlnPosiljaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2" *ngIf="izlazna">
          <div class="col-md-12">
            <div class="btn-group float-right">
              <button type="button" class="btn btn-outline-primary" (click)="SaveItem()"
                [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable || !dozvoliSnimanje"
              ><span
                  class="fa fa-fa fa-save"></span>
                Sačuvaj</button>
              <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="collapsable-container" style="margin-bottom:8px;">
      <div class="collapsable-container-header" (click)="toggleCollapseDetaljiOOtpremi()">
        <span class="btn-collapse" (click)="toggleCollapseDetaljiOOtpremi($event)"><span
            class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'EOTPREMNICA.DETALJIOTPREMI.TITLE' | translate }}</div>
      </div>
      <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsedDetaljiOOtpremi}">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Ulica otpreme -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.ULICAOTPREME.SINGULAR'"
                      formControlName="UlicaOtpreme" [ngClass]="{
                'is-invalid': submitted && fc.UlicaOtpreme.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.UlicaOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.UlicaOtpreme">
                        <span class="error-message" *ngIf="fc.UlicaOtpreme.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Broj u ulici otpreme -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJUULICIOTPREME.SINGULAR'"
                      formControlName="BrojUUliciOtpreme" [ngClass]="{
                'is-invalid': submitted && fc.BrojUUliciOtpreme.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.BrojUUliciOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.BrojUUliciOtpreme">
                        <span class="error-message" *ngIf="fc.BrojUUliciOtpreme.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Poštanski broj otpreme -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.POSTANSKIBROJOTPREME.SINGULAR'"
                      formControlName="PostanskiBrojOtpreme" [ngClass]="{
                'is-invalid': submitted && fc.PostanskiBrojOtpreme.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.PostanskiBrojOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.PostanskiBrojOtpreme">
                        <span class="error-message" *ngIf="fc.PostanskiBrojOtpreme.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Grad otpreme -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.GRADOTPREME.SINGULAR'" formControlName="GradOtpreme"
                      [ngClass]="{
                'is-invalid': submitted && fc.GradOtpreme.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.GradOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.GradOtpreme">
                        <span class="error-message" *ngIf="fc.GradOtpreme.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Kurir -->
        <!-- <div class="row" *ngIf="!angazovanPrevoznik"> -->
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Ime kurira -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input
                      [Type]="'text'"
                      [Label]="'EOTPREMNICA.KURIRIME.SINGULAR'"
                      formControlName="KurirIme"
                      [ngClass]="{'is-invalid': submitted && fc.KurirIme.invalid}" [MaxLength]="50"
                      [disabled]="sopstveniPrevoz || angazovanPrevoznik || !this.izlazna">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.KurirIme.invalid">
                      <span *ngFor="let validation of errorMessages.KurirIme">
                        <span class="error-message" *ngIf="fc.KurirIme.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                     <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                      <span class="error-message"
                        *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsNacinOtpreme && !this.baseFormGroup.errors.checkControlsNacinOtpreme.valid"><span
                          translate="{{this.baseFormGroup.errors.checkControlsNacinOtpreme.message}}"></span></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Prezime kurira -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input
                      [Type]="'text'"
                      [Label]="'EOTPREMNICA.KURIRPREZIME.SINGULAR'"
                      formControlName="KurirPrezime"
                      [ngClass]="{'is-invalid': submitted && fc.KurirPrezime.invalid}"
                      [MaxLength]="50" [disabled]="sopstveniPrevoz || angazovanPrevoznik || !this.izlazna">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.KurirPrezime.invalid">
                      <span *ngFor="let validation of errorMessages.KurirPrezime">
                        <span class="error-message" *ngIf="fc.KurirPrezime.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                     <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                      <span class="error-message"
                        *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsNacinOtpreme && !this.baseFormGroup.errors.checkControlsNacinOtpreme.valid"><span
                          translate="{{this.baseFormGroup.errors.checkControlsNacinOtpreme.message}}"></span></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- LK kurira -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input
                      [Type]="'text'"
                      [Label]="'EOTPREMNICA.KURIRLK.SINGULAR'"
                      formControlName="KurirLK"
                      [ngClass]="{'is-invalid': submitted && fc.KurirLK.invalid}" [MaxLength]="50"
                      [disabled]="sopstveniPrevoz || angazovanPrevoznik || !this.izlazna">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.KurirLK.invalid">
                      <span *ngFor="let validation of errorMessages.KurirLK">
                        <span class="error-message" *ngIf="fc.KurirLK.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                     <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                      <span class="error-message"
                        *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsNacinOtpreme && !this.baseFormGroup.errors.checkControlsNacinOtpreme.valid"><span
                          translate="{{this.baseFormGroup.errors.checkControlsNacinOtpreme.message}}"></span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2" *ngIf="izlazna">
          <div class="col-md-12">
            <div class="btn-group float-right">
              <button type="button" class="btn btn-outline-primary" (click)="SaveItem()"
                [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable || !dozvoliSnimanje"
              ><span
                  class="fa fa-fa fa-save"></span>
                Sačuvaj</button>
              <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="collapsable-container" style="margin-bottom:8px;">
      <div class="collapsable-container-header" (click)="toggleCollapseDetaljiOPrimaocu()">
        <span class="btn-collapse" (click)="toggleCollapseDetaljiOPrimaocu($event)"><span
            class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'EOTPREMNICA.DETALJIOPRIMAOCU.TITLE' | translate }}</div>
      </div>
      <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsedDetaljiOPrimaocu}">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Naziv primaoca -->
              <div class="col-lg-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.NAZIVPRIMAOCA.SINGULAR'"
                      formControlName="NazivPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.NazivPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.NazivPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.NazivPrimaoca">
                        <span class="error-message" *ngIf="fc.NazivPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Naziv primaoca2 -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.NAZIVPRIMAOCA2.SINGULAR'"
                      formControlName="NazivPrimaoca2" [ngClass]="{
                'is-invalid': submitted && fc.NazivPrimaoca2.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.NazivPrimaoca2.invalid">
                      <span *ngFor="let validation of errorMessages.NazivPrimaoca2">
                        <span class="error-message" *ngIf="fc.NazivPrimaoca2.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Ime i prezime primaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.IMEIPREZIMEPRIMAOCA.SINGULAR'"
                      formControlName="ImeIPrezimePrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.ImeIPrezimePrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.ImeIPrezimePrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.ImeIPrezimePrimaoca">
                        <span class="error-message" *ngIf="fc.ImeIPrezimePrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Ulica primaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.ULICAPRIMAOCA.SINGULAR'"
                      formControlName="UlicaPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.UlicaPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.UlicaPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.UlicaPrimaoca">
                        <span class="error-message" *ngIf="fc.UlicaPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Broj u ulici primaoca -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJUULICIPRIMAOCA.SINGULAR'"
                      formControlName="BrojUUliciPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.BrojUUliciPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.BrojUUliciPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.BrojUUliciPrimaoca">
                        <span class="error-message" *ngIf="fc.BrojUUliciPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Poštanski broj primaoca -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.POSTANSKIBROJPRIMAOCA.SINGULAR'"
                      formControlName="PostanskiBrojPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.PostanskiBrojPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.PostanskiBrojPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.PostanskiBrojPrimaoca">
                        <span class="error-message" *ngIf="fc.PostanskiBrojPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Grad primaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.GRADPRIMAOCA.SINGULAR'"
                      formControlName="GradPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.GradPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.GradPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.GradPrimaoca">
                        <span class="error-message" *ngIf="fc.GradPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Dodatno ulica primaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.DODATNOULICAPRIMAOCA.SINGULAR'"
                      formControlName="DodatnoUlicaPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.DodatnoUlicaPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.DodatnoUlicaPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.DodatnoUlicaPrimaoca">
                        <span class="error-message" *ngIf="fc.DodatnoUlicaPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Telefon primaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.TELEFONPRIMAOCA.SINGULAR'"
                      formControlName="TelefonPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.TelefonPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.TelefonPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.TelefonPrimaoca">
                        <span class="error-message" *ngIf="fc.TelefonPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Email primaoca -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.EMAILPRIMAOCA.SINGULAR'"
                      formControlName="EmailPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.EmailPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.EmailPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.EmailPrimaoca">
                        <span class="error-message" *ngIf="fc.EmailPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Pib primaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.PIBPRIMAOCA.SINGULAR'" formControlName="PibPrimaoca"
                      [ngClass]="{
                'is-invalid': submitted && fc.PibPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.PibPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.PibPrimaoca">
                        <span class="error-message" *ngIf="fc.PibPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Matični broj primaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.JBKJSPRIMAOCA.SINGULAR'"
                      formControlName="JBKJSPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.JBKJSPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.JBKJSPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.JBKJSPrimaoca">
                        <span class="error-message" *ngIf="fc.JBKJSPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- JBKJS primaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.MATICNIBROJPRIMAOCA.SINGULAR'"
                      formControlName="MaticniBrojPrimaoca" [ngClass]="{
                'is-invalid': submitted && fc.MaticniBrojPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.MaticniBrojPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.MaticniBrojPrimaoca">
                        <span class="error-message" *ngIf="fc.MaticniBrojPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Gln primaoca -->
              <div class="col-lg-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.GLNPRIMAOCA.SINGULAR'" formControlName="GlnPrimaoca"
                      [ngClass]="{
                'is-invalid': submitted && fc.GlnPrimaoca.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.GlnPrimaoca.invalid">
                      <span *ngFor="let validation of errorMessages.GlnPrimaoca">
                        <span class="error-message" *ngIf="fc.GlnPrimaoca.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2" *ngIf="izlazna">
              <div class="col-md-12">
                <div class="btn-group float-right">
                  <button type="button" class="btn btn-outline-primary" (click)="SaveItem()"
                  [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable || !dozvoliSnimanje"
                ><span
                      class="fa fa-fa fa-save"></span>
                    Sačuvaj</button>
                  <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                    [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>






    <div class="collapsable-container" style="margin-bottom:8px;">
      <div class="collapsable-container-header" (click)="toggleCollapseDetaljiODostavi()">
        <span class="btn-collapse" (click)="toggleCollapseDetaljiODostavi($event)"><span
            class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'EOTPREMNICA.DETALJIODOSTAVI.TITLE' | translate }}</div>
      </div>
      <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsedDetaljiODostavi}">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Ulica dostave -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.ULICADOSTAVE.SINGULAR'"
                      formControlName="UlicaDostave" [ngClass]="{
                'is-invalid': submitted && fc.UlicaDostave.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.UlicaDostave.invalid">
                      <span *ngFor="let validation of errorMessages.UlicaDostave">
                        <span class="error-message" *ngIf="fc.UlicaDostave.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Broj u ulici dostave -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJUULICIDOSTAVE.SINGULAR'"
                      formControlName="BrojUUliciDostave" [ngClass]="{
                'is-invalid': submitted && fc.BrojUUliciDostave.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.BrojUUliciDostave.invalid">
                      <span *ngFor="let validation of errorMessages.BrojUUliciDostave">
                        <span class="error-message" *ngIf="fc.BrojUUliciDostave.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Poštanski broj dostave -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.POSTANSKIBROJDOSTAVE.SINGULAR'"
                      formControlName="PostanskiBrojDostave" [ngClass]="{
                'is-invalid': submitted && fc.PostanskiBrojDostave.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.PostanskiBrojDostave.invalid">
                      <span *ngFor="let validation of errorMessages.PostanskiBrojDostave">
                        <span class="error-message" *ngIf="fc.PostanskiBrojDostave.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Grad dostave -->
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.GRADDOSTAVE.SINGULAR'" formControlName="GradDostave"
                      [ngClass]="{
                'is-invalid': submitted && fc.GradDostave.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.GradDostave.invalid">
                      <span *ngFor="let validation of errorMessages.GradDostave">
                        <span class="error-message" *ngIf="fc.GradDostave.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Napomena dostave -->
            <div class="row">
              <div class="col-md-12">
                    <yt-text-area [Type]="'text'" 
                      [Label]="'EOTPREMNICA.NAPOMENADOSTAVE.SINGULAR'"
                      formControlName="NapomenaDostave"
                      [MaxLength]="500">
                    </yt-text-area>
              </div>
            </div>
            <!-- </div> -->
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <!-- Planirani datum dostave -->
                  <!-- <div class="col-lg-3">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.PLANIRANIDATUMDOSTAVE.SINGULAR'"
                          formControlName="PlaniraniDatumDostave" [ngClass]="{
                'is-invalid': submitted && fc.PlaniraniDatumDostave.invalid
                  }" [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.PlaniraniDatumDostave.invalid">
                          <span *ngFor="let validation of errorMessages.PlaniraniDatumDostave">
                            <span class="error-message" *ngIf="fc.PlaniraniDatumDostave.hasError(validation.type)"><span
                                translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- Planirano vreme dostave -->
                  <!-- <div class="col-lg-3">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.PLANIRANOVREMEDOSTAVE.SINGULAR'"
                          formControlName="PlaniranoVremeDostave" [ngClass]="{
                'is-invalid': submitted && fc.PlaniranoVremeDostave.invalid
                  }" [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.PlaniranoVremeDostave.invalid">
                          <span *ngFor="let validation of errorMessages.PlaniranoVremeDostave">
                            <span class="error-message" *ngIf="fc.PlaniranoVremeDostave.hasError(validation.type)"><span
                                translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- Stvarno datum dostave -->
                  <!-- <div class="col-lg-3">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.STVARNOVREMEOTPREME.SINGULAR'"
                          formControlName="StvarniDatumDostave" [ngClass]="{
                'is-invalid': submitted && fc.StvarniDatumDostave.invalid
                  }" [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.StvarniDatumDostave.invalid">
                          <span *ngFor="let validation of errorMessages.StvarniDatumDostave">
                            <span class="error-message" *ngIf="fc.StvarniDatumDostave.hasError(validation.type)"><span
                                translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- Stvarno vreme dostave -->
                  <!-- <div class="col-lg-3">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.STVARNOVREMEDOSTAVE.SINGULAR'"
                          formControlName="StvarnoVremeDostave" [ngClass]="{
                'is-invalid': submitted && fc.StvarnoVremeDostave.invalid
                  }" [MaxLength]="50">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.StvarnoVremeDostave.invalid">
                          <span *ngFor="let validation of errorMessages.StvarnoVremeDostave">
                            <span class="error-message" *ngIf="fc.StvarnoVremeDostave.hasError(validation.type)"><span
                                translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="row mb-2" *ngIf="izlazna">
              <div class="col-md-12">
                <div class="btn-group float-right">
                  <button type="button" class="btn btn-outline-primary" (click)="SaveItem()"
                  [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable || !dozvoliSnimanje"
                ><span
                      class="fa fa-fa fa-save"></span>
                    Sačuvaj</button>
                  <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                    [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Prevoz -->
    <!-- <div class="row" *ngIf="angazovanPrevoznik"> -->
    <div class="row" [hidden]="!angazovanPrevoznik && !sopstveniPrevoz">
      <div class="col-md-12">
        <yt-eotpremnica-prevoz-update-container
          #baseInlineContainer1
          [DetailModelData]="modelData.MainList.DetailList[1]"
          [ParentPropertyName]="'EOtpremnicaID'"
          [ParentPropertyValue]="Item?.ID"
          [Parameters]="TransferParameters"
          [Level]="'document'"
        >
        </yt-eotpremnica-prevoz-update-container>
      </div>
    </div>

    <!-- Opasne materije -->
    <div class="row">
      <div class="col-md-12">
        <yt-eotpremnica-opasna-materija-update-container #baseInlineContainer2
          [DetailModelData]="modelData.MainList.DetailList[2]" [ParentPropertyName]="'EOtpremnicaID'"
          [ParentPropertyValue]="Item?.ID" [Parameters]="TransferParameters" [Level]="'document'">
        </yt-eotpremnica-opasna-materija-update-container>
      </div>
    </div>

    <!-- Stavke otpremnice -->
    <div class="row">
      <div class="col-md-12">
        <!-- *ngIf="modelData?.MainList?.DetailList?.length > 0 && Item?.ID" -->
        <yt-eotpremnica-stavka-update-container *ngIf="modelData?.MainList?.DetailList?.length > 0 && Item?.ID"
           #baseInlineContainer [DetailModelData]="modelData.MainList.DetailList[0]"
          [ParentPropertyName]="'EOtpremnicaID'" [ParentPropertyValue]="Item?.ID" [Parameters]="TransferParameters"
          [Level]="'document'">
        </yt-eotpremnica-stavka-update-container>        
      </div>
    </div>
  </form>
</div>